<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>預算/勞退匯入</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>預算分配</span></li>
          <li><span>預算/勞退匯入</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="left">
              <div>學年度/類別查詢:
                <select v-model="search.schYear">
                  <option :value="null">請選擇</option>
                  <option v-for="item in schYearList" :key="item" :value="item">{{item}}</option>
                </select>　
                <select v-model="search.fileType">
                  <option :value="null">請選擇</option>
                  <option :value="1">總預算</option>
                  <option :value="2">勞/退費</option>
                </select>　
                <a href="#" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
                <a href="#" @click.prevent="searchClear" class="btn-upload btn btn-primary" style="background-color:#666; border-color:#666;">清空</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body" align="left">
              <div align="left">
                選擇上傳檔案 :
                <select v-model="form.fileType">
                  <option :value="null" selected>請選擇</option>
                  <option :value="1">總預算</option>
                  <option :value="2">勞/退費</option>
                </select>　<input type="file" ref="file" style="display: inline; max-width: 180px;"> (限EXCEL檔)
                <a href="#" @click.prevent="fileUpload" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">上傳</a>
              </div><br>
              <a href="/bursary/files/預算匯入表.xlsx">總預算匯入範例</a>　　<a href="/bursary/files/勞退匯入表.xlsx">勞退匯入範例</a>
              <table ref="table" class="table table-no-more table-bordered table-striped mb-none">
                <thead>
                  <tr>
                    <th class="text-center" width="8%">序號</th>
                    <th class="text-center" width="13%">學年度</th>
                    <th class="text-center" width="13%">上傳類別</th>
                    <th class="text-center" width="18%">上傳文件記錄</th>
                    <th class="text-center" width="18%">上傳日期</th>
                    <th class="text-center" width="18%">上傳帳號</th>
                    <!-- <th class="text-center" width="12%"></th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in list" :key="index">
                    <td data-title="序號" class="text-center">{{index + 1}}</td>
                    <td data-title="學年度" class="text-center">{{item.schYear}}</td>
                    <td data-title="上傳類別" class="text-center">{{item.fileType}}</td>
                    <td data-title="上傳文件記錄" class="text-center">
                      <a :href="item.filePath" target="_blank">{{item.fileName}}</a>
                    </td>
                    <td data-title="上傳日期" class="text-center">{{item.createDate}}</td>
                    <td data-title="上傳帳號" class="text-center">{{item.createUser}}</td>
                    <!-- <td data-title="勞保/勞退粘存單" class="text-center">
                      <a href="#" v-if="item.fileType=='勞/退費'" @click.prevent="download(item.id)" class="btn btn-sm btn-default" style="font-size: 0.7em;">勞保/勞退粘存單</a>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      search: {
        schYear: null,
        fileType: null,
      },
      form: {
        fileType: null,
      },
      list: [],
      schYearList: [],
    };
  },
  mounted() {
    this.$http.get("/api/budget/import-file-yearlist").then((a) => {
      this.schYearList = a.body;
    });
    this.load();
  },
  methods: {
    load() {
      this.$http
        .get("/api/budget/import-file", {
          params: {
            schYear: this.search.schYear,
            fileType: this.search.fileType,
          },
        })
        .then((a) => {
          this.list = a.body;
          this.$nextTick((b) => {
            $(this.$refs.table).DataTable({
              bFilter: false,
              bLengthChange: false,
              language: {
                info: "第 _PAGE_ 頁 / 總共 _PAGES_ 頁",
              },
              columnDefs: [
                {
                  targets: 0,
                  orderable: false,
                },
                {
                  targets: 6,
                  orderable: false,
                },
              ],
              order: [1, "desc"],
              columns: [
                { width: "8%" },
                { width: "13%" },
                { width: "13%" },
                { width: "18%" },
                { width: "18%" },
                { width: "18%" },
                { width: "12%" }
              ],
              destroy: true
            });
          });
        });
    },
    searchSubmit() {
      this.load();
    },
    fileUpload() {
      if (!this.form.fileType) {
        alert("請選擇上傳檔案類型");
        return false;
      }
      let file = this.$refs.file.files[0];
      if (!file) {
        alert("尚未選擇上傳檔案");
        return false;
      }
      if (
        file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        alert("請上傳EXCEL檔(xlsx)");
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      formData.append("fileType", this.form.fileType);
      this.$http
        .post("/api/budget", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((a) => {
          if (a.body.status) {
            alert("上傳成功");
            this.$refs.file.value = null;
            this.form.fileType = null;
            this.load();
          } else {
            alert(a.body.msg);
            console.log(a.body.exstr);
            this.$refs.file.value = null;
            this.form.fileType = null;
          }
        });
    },
    searchClear() {
      this.search.schYear = null;
      this.search.fileType = null;
    },
    download(id) {
      this.$http
        .post(
          "/api/budget/export-labor/" + id,
          {},
          { responseType: "arraybuffer" }
        )
        .then((res) => {
          this.download2File(res);
        });
    },
  },
};
</script>

<style>
</style>
